export default {
  clickfunnels: {
    integration: 'post',
    pipedream_url: 'https://99604d96175f3ba2216c3da7f68930ba.m.pipedream.net',
    name: 'Clickfunnels v1.0',
    logourl: 'https://cdn.filestackcontent.com/IZp4mfd5QcO3Xms2YvPI',
    helpdocs: '',
    meta: {
      page_url: {
        control: 'text',
        title: 'Optin URL',
        desc: 'URL to Clickfunnels v1.0 Squeeze page',
      },
    },
  },
  sendinblue: {
    integration: 'apikey',
    pipedream_url: 'https://123cdcae40a9b159752d59c4f60a933d.m.pipedream.net',
    name: 'SendInBlue',
    logourl: 'https://cdn.filestackcontent.com/e7aYqXTgTien6cDw8i99',
    helpdocs: '',
    meta: {
      list_id: {
        control: 'text',
        title: 'List ID',
        desc: 'ID for your list inside of your SendinBlue account (must be a number).',
      },
    },
  },
  activecampaign: {
    integration: 'apikey',
    pipedream_url: 'https://c8ac7476966b4bc81ee5d56217723c2c.m.pipedream.net',
    name: 'ActiveCampaign',
    logourl: 'https://cdn.filestackcontent.com/WjzNxbjaSXqNzbbi0ZdJ',
    helpdocs: '',
    meta: {
      api_url: {
        control: 'text',
        title: 'API URL',
        desc: 'The URL given inside Settings > Developer in your ActiveCampaign account.',
      },
      list_id: {
        control: 'text',
        title: 'List ID',
        desc: 'ID for your list inside of your ActiveCampaign account (must be a number).',
      },
    },
  },
  getresponse: {
    integration: 'apikey',
    pipedream_url: 'https://a4493216339ff21241381732a59582dd.m.pipedream.net',
    name: 'GetResponse',
    logourl: 'https://cdn.filestackcontent.com/gSFtfLBRJuk3Z6AEr6uX',
    helpdocs: '',
    meta: {
      list_id: {
        control: 'text',
        title: 'List Token',
        desc: 'List token for your list inside of your GetResponse account (found in List > Settings).',
      },
    },
  },
  drip: {
    integration: 'apikey',
    pipedream_url: 'https://adb7551afbace37f1aef2ff08ba5f243.m.pipedream.net',
    name: 'Drip',
    logourl: 'https://cdn.filestackcontent.com/6voSprthQjecSKLYzvqP',
    helpdocs: '',
    meta: {
      account_id: {
        control: 'text',
        title: 'Account ID',
        desc: 'Account ID for your your Drip account.',
      },
      campaign_id: {
        control: 'text',
        title: 'Email Series Campaign ID',
        desc: 'Campaign ID for your list inside of your Drip account.',
      },
      workflow_id: {
        control: 'text',
        title: 'Workflow ID',
        desc: 'Workflow ID for your list inside of your Drip account. (* note: will override Campaign ID)',
      },
    },
  },
  webhook: {
    integration: 'post',
    pipedream_url: 'https://0cd73d24fe29496266eb55366f715dea.m.pipedream.net',
    name: 'HTTP Webhook',
    logourl: 'https://cdn.filestackcontent.com/D6VNzpnRaRtbjPvNvbkQ',
    helpdocs: '',
    meta: {
      page_url: {
        control: 'text',
        title: 'Webhook URL',
        desc: 'URL to Webhook where we will send email too.',
      },
    },
  },
  zapier: {
    integration: 'post',
    pipedream_url: 'https://32f0568f03846bc09bdbb18faca3cd53.m.pipedream.net',
    name: 'Webhooks by Zapier',
    logourl: 'https://cdn.filestackcontent.com/1t6m53ZGTpGIUqI0gwx9',
    helpdocs: '',
    meta: {
      page_url: {
        control: 'text',
        title: 'Zapier Webhook Post URL',
        desc: 'Copy the generated custom webhook URL Zapier created for you in a Hook Catch action.',
      },
    },
  },
  convertkit: {
    integration: 'apikeyapisecret',
    pipedream_url: 'https://fc2974164f8f22e9efcbe80f6cca0beb.m.pipedream.net',
    name: 'ConvertKit',
    logourl: 'https://cdn.filestackcontent.com/QF7B1etWQE2CR9MNylUn',
    helpdocs: '',
    meta: {
      form_id: {
        control: 'text',
        title: 'Form Id',
        desc: 'Subscribe an email address to one of your forms.',
      },
      tags: {
        control: 'multiselect',
        title: 'Tags',
        desc: 'Tag your sign ups...',
      },
    },
  },
  mailchimp: {
    integration: 'apikey',
    pipedream_url: 'https://769fc9dcbab96e17b4986076619b2094.m.pipedream.net',
    name: 'MailChimp',
    logourl: 'https://cdn.filestackcontent.com/7PtdDE92Thupr4w1bDp8',
    helpdocs: '',
    meta: {
      list_id: {
        control: 'text',
        title: 'List Id',
        desc: 'The unique ID for the list.',
      },
      status_if_new: {
        control: 'select',
        options: [
          { label: 'subscribed', value: 'subscribed' },
          { label: 'unsubscribed', value: 'unsubscribed' },
          { label: 'cleaned', value: 'cleaned' },
          { label: 'pending', value: 'pending' },
          { label: 'transactional', value: 'transactional' },
        ],
        title: 'Status If New',
        desc: 'Subscribers status. This value is required only if the email address is not already present on the list...',
      },
    },
  },
  hubspot: {
    integration: 'apikey',
    pipedream_url: 'https://c865afce5b7cadbb03d11e818bbbf565.m.pipedream.net',
    name: 'Hubspot',
    logourl: 'https://cdn.filestackcontent.com/arvaOHUfSeO8A0y64xzj',
    helpdocs: '',
    meta: {
      list_id: {
        control: 'text',
        title: 'List ID',
        desc: 'List ID for your list inside of your Hubspot account.',
      },
    },
  },
  markethero: {
    integration: 'apikey',
    pipedream_url: 'https://a797e2491c7f96def71223d7f89b8907.m.pipedream.net',
    name: 'Market Hero',
    logourl: 'https://cdn.filestackcontent.com/9NgCY4RCSNC9LAubSWpW',
    helpdocs: '',
    meta: {
      tag: {
        control: 'text',
        title: 'Tag',
        desc: 'Give this contact a Tag to organize in your Market Hero account.',
      },
    },
  },
  maropost: {
    integration: 'apikey',
    pipedream_url: 'https://44c35d5b51d5c7f3112714ca989aaad9.m.pipedream.net',
    name: 'Maropost',
    logourl: 'https://cdn.filestackcontent.com/UJxkMgrlTlaKkdNkuZhg',
    helpdocs: '',
    meta: {
      account_id: {
        control: 'text',
        title: 'Account ID',
        desc: 'Account ID for your Maropost account.',
      },
      list_id: {
        control: 'text',
        title: 'List ID',
        desc: 'List ID for the list your want to subscribe users too.',
      },
    },
  },
  sendlane: {
    integration: 'apikey',
    pipedream_url: 'https://1f0f6472a6e8ed87336753544fe31bcc.m.pipedream.net',
    name: 'Sendlane',
    logourl: 'https://cdn.filestackcontent.com/2omFBAATQWaDcKGoOWKi',
    helpdocs: '',
    meta: {
      hash_key: {
        control: 'text',
        title: 'Hash Key',
        desc: 'Required',
      },
      list_id: {
        control: 'text',
        title: 'List ID',
        desc: 'List ID for the list your want to subscribe users too.',
      },
    },
  },
  ontraport: {
    integration: 'apikey',
    pipedream_url: 'https://d357ab4434889cdc5b1e00789d0e6f6c.m.pipedream.net',
    name: 'Ontraport',
    logourl: 'https://cdn.filestackcontent.com/CdxefTTRO6czrk5aMgJd',
    helpdocs: '',
    meta: {
      app_id: {
        control: 'text',
        title: 'App Id',
        desc: 'Required',
      },
    },
  },
  sender: {
    integration: 'apikey',
    pipedream_url: 'https://165d87c12aea256f5578434d773696a0.m.pipedream.net',
    name: 'Sender',
    logourl: 'https://cdn.filestackcontent.com/JjO7WF39QdS2528uvMWj',
    helpdocs: '',
    meta: {
      group_id: {
        control: 'text',
        title: 'Group ID',
        desc: 'Add subscriber to a group in your Sender account.',
      },
    },
  },
  moosend: {
    integration: 'apikey',
    pipedream_url: 'https://eb26529000ebf3d93de7105abb0eae80.m.pipedream.net',
    name: 'Moosend',
    logourl: 'https://cdn.filestackcontent.com/iGgTHGqkT0FcZAl4ppHw',
    helpdocs: '',
    meta: {
      mailinglist_id: {
        control: 'text',
        title: 'Mailing List ID',
        desc: 'Required - Add subscriber to a Mailing List in your Moosend account.',
      },
    },
  },
  campaignmonitor: {
    integration: 'apikey',
    pipedream_url: 'https://3c1dbdc5131d53b5e105ca5c9114e21f.m.pipedream.net',
    name: 'Campaign Monitor',
    logourl: 'https://cdn.filestackcontent.com/5NhFtmLlQomGvpsS0mQU',
    helpdocs: '',
    meta: {
      list_id: {
        control: 'text',
        title: 'List ID',
        desc: 'Required - Add subscriber to a List in your Campaign Monitor account.',
      },
    },
  },
  mailerlite: {
    integration: 'apikey',
    pipedream_url: 'https://dcea33b42f66fc6832b81e6d3a015b24.m.pipedream.net',
    name: 'MailerLite',
    logourl: 'https://cdn.filestackcontent.com/LlpNxTPNTAqQJsZ0PW0p',
    helpdocs: '',
    meta: {
      group_id: {
        control: 'text',
        title: 'Group ID',
        desc: 'Required - Add subscriber to a Group in your MailerLite account.',
      },
    },
  },
  campaigner: {
    integration: 'apikey',
    pipedream_url: 'https://07dd754c7484370ace7db1d254ccf2fb.m.pipedream.net',
    name: 'Campaigner',
    logourl:
      'https://media.glassdoor.com/sqll/2382148/campaigner-squarelogo-1544533028004.png',
    helpdocs: '',
    meta: {
      list_id: {
        control: 'text',
        title: 'List ID',
        desc: 'Required - Add subscriber to a List in your Campaigner account.',
      },
    },
  },
  klaviyo: {
    integration: 'apikey',
    pipedream_url: 'https://eb49c0cecd36a7a4c58c99dfd5d9d1b4.m.pipedream.net',
    name: 'Klaviyo',
    logourl:
      'https://www.klaviyo.com/wp-content/uploads/2019/08/cropped-favicon-512x512-192x192.png',
    helpdocs: '',
    meta: {
      list_id: {
        control: 'text',
        title: 'List ID',
        desc: 'Required - Add subscriber to a List in your Klaviyo account.',
      },
    },
  },
  keap: {
    comingsoon: true,
    integration: 'apikey',
    pipedream_url: 'https://d131cc6ff64933158d42c8b596fb7c9f.m.pipedream.net',
    name: 'Keap',
    logourl: 'https://cdn.worldvectorlogo.com/logos/keap.svg',
    helpdocs: '',
    meta: {
      list_id: {
        control: 'text',
        title: 'List ID',
        desc: 'List ID for your list inside of your Aweber account.',
      },
    },
  },
  constantcontact: {
    comingsoon: true,
    integration: 'apikey',
    pipedream_url: 'https://a3db106af4b39be4e31f61ffe097d4f5.m.pipedream.net',
    name: 'ConstantContact',
    logourl:
      'https://www.simplesat.io/wp-content/uploads/elementor/thumbs/constant-contact-logo-icon-p9hsga48266fcoivr16337potluvf56ivykgv75og4.png',
    helpdocs: '',
    meta: {
      list_id: {
        control: 'text',
        title: 'List ID',
        desc: 'List ID for your list inside of your ConstantContact account.',
      },
    },
  },
  aweber: {
    comingsoon: true,
    integration: 'apikey',
    pipedream_url: 'https://a3db106af4b39be4e31f61ffe097d4f5.m.pipedream.net',
    name: 'Aweber',
    logourl:
      'https://wpforms.com/wp-content/uploads/2016/02/addon-icon-aweber.png',
    helpdocs: '',
    meta: {
      list_id: {
        control: 'text',
        title: 'List ID',
        desc: 'List ID for your list inside of your Aweber account.',
      },
    },
  },
  zoom: {
    comingsoon: true,
    integration: 'apikey',
    pipedream_url: '',
    name: 'Zoom Webinar',
    logourl: 'https://cdn.worldvectorlogo.com/logos/zoom-5.svg',
    helpdocs: '',
    meta: {
      list_id: {
        control: 'text',
        title: 'Webinar ID',
        desc: 'Webinar ID for your list inside of your Zoom account.',
      },
    },
  },
  sendpulse: {
    comingsoon: true,
    integration: 'apikey',
    pipedream_url: '',
    name: 'SendPulse',
    logourl:
      'https://s3.amazonaws.com/neverbounce-hosted/images/integrations/square/sendpulse-square.png',
    helpdocs: '',
    meta: {},
  },
  clickfunnels2: {
    comingsoon: true,
    integration: 'apikey',
    pipedream_url: '',
    name: 'ClickFunnels v2.0',
    logourl: 'https://cdn.filestackcontent.com/IZp4mfd5QcO3Xms2YvPI',
    helpdocs: '',
    meta: {},
  },
}
